import React, { useState } from "react";
import { Button, Form, Grid, Header, Modal } from "semantic-ui-react";
import SlidingPane from "react-sliding-pane";
import { connect } from "react-redux";
import {
  createLocation,
  updateLocation,
} from "../../../../redux/actions/location";
import DropZone from "../../../../components/DropZone";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ErrorMessage from "../../../../components/ErrorMessage";

const EditLocationSidePain = ({ location, children, update, create }) => {
  const [loading, setLoading] = useState(false);
  const [sidePainOpen, setSidePainOpen] = useState(false);
  const [error, setError] = useState(null);

  const [id] = useState(location._id);
  const [imageUrl] = useState(location.image_url || null);
  const [file, setFile] = useState(null);
  const [name, setName] = useState(location.name || "");
  const [nameLowerCase, setNameLowercase] = useState(
    location.name_lower_case || "",
  );
  const [slug, setSlug] = useState(location.slug || "");
  const [about, setAbout] = useState(location.about || "");

  const onSubmit = async () => {
    setError(null);
    setLoading(true);

    const data = {
      name,
      file,
      name_lower_case: nameLowerCase,
      slug,
      about,
    };

    var formData = new FormData();

    for (var key in data) {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    }

    try {
      if (id) {
        await update(id, formData);
      } else {
        await create(formData);
      }

      setSidePainOpen(false);
    } catch (e) {
      setError(e);
    }

    setLoading(false);
  };

  return (
    <>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="overlay"
        isOpen={sidePainOpen}
        title={
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header
                  floated={"left"}
                  content={id ? "Edit Location" : "Create Location"}
                />

                <Button
                  primary
                  content={"Save"}
                  floated={"right"}
                  loading={loading}
                  onClick={onSubmit}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
        onRequestClose={() => setSidePainOpen(false)}
      >
        <Form fluid>
          {error && <ErrorMessage error={error} />}
          <Form.Group>
            <Form.Field width={4}>
              <label>Image</label>
            </Form.Field>
            <Form.Field width={12}>
              <DropZone
                onDrop={(acceptedFiles) => setFile(acceptedFiles[0])}
                multiple={false}
                accept="image/*"
                icon={"image"}
                image={(file && file.preview) || imageUrl}
                placeholder={"Drag location image here or click to upload"}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>Name</label>
            </Form.Field>
            <Form.Input
              fluid
              defaultValue={name}
              width={12}
              placeholder="Name"
              autoComplete={"off"}
              onChange={(e, { value }) => setName(value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>About</label>
            </Form.Field>
            <Form.TextArea
              defaultValue={about}
              width={12}
              placeholder="About"
              rows={8}
              autoComplete={"off"}
              onChange={(e, { value }) => setAbout(value)}
            />
          </Form.Group>
        </Form>
      </SlidingPane>
      <div onClick={() => setSidePainOpen(true)}>{children}</div>
    </>
  );
};

const mapStateToProps = ({ firebase }) => ({});

const mapDispatchToProps = (dispatch) => ({
  create: (data) => dispatch(createLocation(data)),
  update: (id, data) => dispatch(updateLocation(id, data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditLocationSidePain);
